import { useMutation, useQueryClient } from '@tanstack/react-query';
import { validatedApi } from '../../../lib/api/validated-client';
import type { LockSlotRequest, LockSlotResponse } from '@lov/shared';

export function useSlotLock() {
  const queryClient = useQueryClient();

  return useMutation<LockSlotResponse, Error, LockSlotRequest>({
    mutationFn: async (params) => {
      return validatedApi.post<LockSlotResponse>('/bookings/lock-slot', params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['availability'] });
    },
  });
}

export interface UnlockSlotParams {
  venueId: string;
  date: string;
  startTime: string;
  endTime: string;
  inventoryItems?: { venueInventoryId: string }[];
  lockId: string;
  addonInventoryIds?: string[];
}

export function useUnlockSlot() {
  const queryClient = useQueryClient();

  return useMutation<{ released: boolean }, Error, UnlockSlotParams>({
    mutationFn: async (params) => {
      // DELETE with a request body is sent via config.data (axios convention)
      return validatedApi.delete<{ released: boolean }>('/bookings/lock-slot', { data: params });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['availability'] });
    },
  });
}
